import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconDeliveryTruck = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 23,
	height: 17,
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 23 17",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M0 0h15v3h3l4 5.7V14h-2.7a3.3 3.3 0 0 1-6.1 0h-4a3.3 3.3 0 0 1-6.1 0H0V0zm3 12a3.3 3.3 0 0 1 6.3 0H13V2H2v10h1zm12-2a3.2 3.2 0 0 1 4.3 2h.7V9.3L17 5h-2v5zm-8.8 1.8a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4zm10 0a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4z",
		clipRule: "evenodd"
	})
});
export default SvgIconDeliveryTruck;
